export const shouldSkipOffersByUserIdQueryForCurrentBrand = true;
